<template>
    <div @click.prevent="updateModelValue(!props.modelValue)" class="text-black text-sm font-normal" :class="{
        'opacity-60': props.modelValue,
        'opacity-50': !props.modelValue,
    }">Active</div>
    <vx-switch size="sm" :loading="props.loading" :modelValue="props.modelValue"
        @update:modelValue="updateModelValue">
    </vx-switch>
</template>
<script setup>
import { VxSwitch } from '@voxie/frontend-components';

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue']);

const updateModelValue = (event) => {
    if (props.loading) {
        return;
    }

    emit('update:modelValue', event);
}
</script>
